import "react-quill/dist/quill.snow.css";
import axios from "axios";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import LoaderComponent from "../../utlis/LoderComponent";

import {
  API_HEADER,
  tl_remotesitevisit_url,
  get_project_details_url,
} from "../../config";

const NoSiteVisit = ({ visitType }) => {
  const { id } = useParams();
  const sitevisittype = { visitType }.visitType;

  const [siteVisitStatus, setSiteVisitStatus] = useState("");
  const [noSiteVisitReasons, setNoSiteVisitReasons] = useState("");
  const [action, setAction] = useState();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [percent, setPercent] = useState(0);
//   const [loading, setLoading] = useState(false);

  const fetchData = async (ids) => {
    try {
      const response = await axios.get(
        `${get_project_details_url}/${ids}`,
        API_HEADER
      );
      const { record } = response.data;

      setSiteVisitStatus(record.site_visit_status);
      setNoSiteVisitReasons(record.no_visit_reason);
      setAction(record.site_visit_status);
    } catch (error) {}
  };

  useEffect(() => {
    fetchData(id);
  }, [id]);

  const CONFIG_Token2 = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "multipart/form-data",
    },
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      setPercent(percentCompleted);
    },
  };

  const navigate = useNavigate();

  const handleRemoteSiteVisit = async (e) => {
    e.preventDefault();
    setIsSubmitting(false);

    try {
      // setLoading(true); // Show loader
      setIsSubmitting(true);

      const formDataToSend = new FormData();

      formDataToSend.append("project_id", id);
      formDataToSend.append("site_visit_type", sitevisittype);
      formDataToSend.append("no_visit_reason", noSiteVisitReasons);
      formDataToSend.append("site_visit_status", 12);
      const response = await axios.post(
        `${tl_remotesitevisit_url}`,
        formDataToSend,
        CONFIG_Token2
      );
      if (response.status === 200 && response.data.status == 1) {
        toast.success("Reason added successfully");
        navigate("/dashboard");
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
    } finally {
      // setLoading(false); // Hide loader
      setIsSubmitting(false);
    }
  };

  const handleSiteVisitReason = (e) => {
    setNoSiteVisitReasons(e.target.value);
  };

  return (
    <>
      {siteVisitStatus == 0 ? (
        <>
          <LoaderComponent isSubmitting={isSubmitting} percent={percent} />
          <form
            method="post"
            onSubmit={handleRemoteSiteVisit}
            encType="multipart/form-data"
          >
            <div className="container my-4">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-12 mb-3">
                  <label
                    htmlFor="nositevisitreasons"
                    className="form-label lightgreen fs-6"
                  >
                    Reasons For No Site Visit
                    <span style={{ color: "red" }}>*</span>
                  </label>

                  <textarea
                    rows="4"
                    cols="50"
                    type="text"
                    className={`form-control borderlightgreen`}
                    id="no_site_visit_reasons"
                    required
                    name="no_site_visit_reasons"
                    value={noSiteVisitReasons}
                    onChange={handleSiteVisitReason}
                  />
                </div>
              </div>

              <div className="col-12 mt-3 d-flex justify-content-end gap-3 pr-0">
                <button type="submit" className="btn btn-success ">
                  Submit
                </button>
              </div>
            </div>
            {/* {loading && <div className="loader"></div>} */}
            {/* {isSubmitting && <div className="loader"></div>} */}
          </form>
        </>
      ) : (
        <form
          method="post"
          // onSubmit={handleRemoteSiteVisit}
          encType="json/form-data"
        >
          <div className="container my-4">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12 mb-3 ">
                <label
                  htmlFor="nositevisitreasons"
                  className="form-label lightgreen fs-6"
                >
                  Reasons For No Site Visit
                  <span style={{ color: "red" }}>*</span>
                </label>

                <textarea
                  rows="4"
                  cols="50"
                  type="text"
                  className={`form-control borderlightgreen`}
                  id="no_site_visit_reasons"
                  required
                  name="no_site_visit_reasons"
                  value={noSiteVisitReasons}
                  // onChange={handleSiteVisitReason}
                  disabled
                />
              </div>
            </div>
          </div>
          {/* {loading && <div className="loader"></div>} */}
          {isSubmitting && <div className="loader"></div>}
        </form>
      )}
    </>
  );
};

export default NoSiteVisit;
